"use client";

import React, { useMemo } from "react";
import { usePathname } from "next/navigation";
import Link from "next/link";

const Breadcrumbs: React.FC<{ variant?: "arrow" }> = ({ variant }) => {
  const pathname = usePathname();
  const breadcrumbLinks = useMemo(() => {
    if (!pathname) return [];

    const pathSegments = pathname
      .split("/")
      .filter((segment) => segment !== "");

    return ["home", ...pathSegments].map((segment, index, array) => {
      const href = "/" + array.slice(1, index + 1).join("/");
      return { name: segment, href, isLast: index === array.length - 1 };
    });
  }, [pathname]);

  return (
    <nav className="text-gray-500  text-lg flex items-start gap-2">
      {breadcrumbLinks.map((crumb, index) => (
        <span key={crumb.href} className="flex items-center">
          <Link
            href={crumb.href}
            className={`hover:underline capitalize ${
              crumb.isLast ? "text-themeColor" : ""
            }`}
          >
            {crumb.name.replace(/-/g, " ")}
          </Link>
          {index < breadcrumbLinks.length - 1 && (
            <span className="mx-2">
              {variant === "arrow" ? <Arrow /> : "/"}
            </span>
          )}
        </span>
      ))}
    </nav>
  );
};

export default Breadcrumbs;

const Arrow = () => {
  return (
    <svg
      width="8"
      height="19"
      viewBox="0 0 8 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1265_173834)">
        <path
          d="M1.3966 5.12055C1.10362 4.82757 1.10374 4.35254 1.39685 4.0597C1.68972 3.7671 2.1643 3.76717 2.4571 4.05986L7.70605 9.307C7.7992 9.39957 7.87313 9.50964 7.92358 9.63089C7.97403 9.75214 8 9.88217 8 10.0135C8 10.1448 7.97403 10.2749 7.92358 10.3961C7.87313 10.5174 7.7992 10.6274 7.70605 10.72L2.45705 15.9699C2.16435 16.2627 1.68973 16.2627 1.397 15.97C1.10431 15.6773 1.10429 15.2027 1.39695 14.91L5.58407 10.7221C5.97454 10.3316 5.97451 9.69846 5.58401 9.30796L1.3966 5.12055Z"
          fill="#2F364B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1265_173834">
          <rect
            width="8"
            height="18"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
